import { ABANDONED_CHAT_SESSION_ID } from './sessionId';
import { updateSessionId } from '../actions/ucmaActions';
import { getStore } from '../store/chatStore';

export default function abandonAllChats() {
    getStore().chats.forEach(chat => {
        updateSessionId(chat, ABANDONED_CHAT_SESSION_ID);
    });
}
